import {CircleAlert} from 'lucide-react';

export interface CapacityRetryPresentation {
  id:string;
  nativeThreadId:string;
  turnId:string;
  phase:'waiting'|'retrying'|'exhausted';
  retryCount:number;
  maxRetries:number;
  message?:string;
}

export function CapacityRetryNotice({state,error=''}:{state:CapacityRetryPresentation;error?:string}){
  const exhausted=state.phase==='exhausted';
  const detail=state.message||error;
  return <div className="chat-capacity-notice" role={exhausted?'alert':'status'} aria-live="polite" aria-atomic="true" data-capacity-id={state.id} data-native-thread-id={state.nativeThreadId} data-turn-id={state.turnId}>
    <CircleAlert className="chat-capacity-icon" size={23} strokeWidth={1.9} aria-hidden="true"/>
    <div className="chat-capacity-content">
      <span>{detail||(exhausted?'模型当前繁忙，自动重试已结束':'模型当前繁忙，正在自动重试。')}</span>
      {detail&&<span>{exhausted?'自动重试已结束':'正在自动重试…'}</span>}
      {!exhausted&&<span className="chat-capacity-progress">{state.retryCount>0?`正在重试 · ${state.retryCount}/${state.maxRetries}`:'正在重试…'}</span>}
    </div>
  </div>;
}
